import {gql} from '@apollo/client';
import {Empty, Skeleton} from 'antd';
import Arts, {GqlArtFragment} from 'src/components/Arts';
import {useAddress, useSubscription} from 'src/hooks';
import {SubscriptionMyArts} from './__generated__/SubscriptionMyArts';

const GQL_ARTS = gql`
  subscription SubscriptionMyArts($id: ID!) {
    player(subgraphError: allow, id: $id) {
      id
      arts(orderBy: mintedAt, orderDirection: desc, where: {mintedAt_gt: 0}) {
        ...ArtFragment
      }
    }
  }
  ${GqlArtFragment}
`;

export default function Home() {
  const address = useAddress();

  const {data, loading} = useSubscription<SubscriptionMyArts>(GQL_ARTS, {
    variables: {
      id: address,
    },
  });

  return (
    <>
      <h1>My Art</h1>
      <Skeleton loading={loading || !address} active={loading}>
        {data?.player?.arts && data.player.arts.length === 0 ? (
          <Empty description='You do not have any minted art yet.' />
        ) : (
          <Arts arts={data?.player?.arts} />
        )}
      </Skeleton>
    </>
  );
}
